export default __webpack_public_path__ + "6f3b1bc852458ed42a80e2c144cfb26e.jpg";